import React from 'react';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const NoActivities = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <Icon icon="illustration-4" />
      <Typography variant="p" size="sm" color="neutral-500">
        No activities yet
      </Typography>
    </div>
  );
};

export default NoActivities;
